import type { ComponentProps, KeyboardEvent } from 'react';
import { forwardRef } from 'react';
import { cx } from 'classix';

import { createFieldErrorId } from './utils';

import styles from './styles/Form.module.css';

type TextAreaProps = ComponentProps<'textarea'> & {
	'data-test-id'?: string;
};

/**
 * @deprecated use `TextArea` from `@launchpad-ui/components` instead
 *
 * https://launchpad.launchdarkly.com/?path=/docs/components-forms-textfield--docs#multi%20line
 */
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({ className, 'data-test-id': testId = 'text-area', ...props }, ref) => {
		const onKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
			if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
				e.stopPropagation();
			}
			if (e.key === 'Escape') {
				e.nativeEvent.stopImmediatePropagation();
			}
		};

		return (
			<textarea
				{...props}
				className={cx(styles.formInput, className)}
				ref={ref}
				data-test-id={testId}
				aria-describedby={props['aria-describedby'] || createFieldErrorId(props.id)}
				onKeyDown={onKeyDown}
			/>
		);
	},
);

TextArea.displayName = 'TextArea';

export { TextArea };
export type { TextAreaProps };
